import { render, staticRenderFns } from "./activity-1.vue?vue&type=template&id=66604c64&"
import script from "./activity-1.vue?vue&type=script&lang=js&"
export * from "./activity-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports